import { ApiError, handleApiError } from '@/handleApiError'
import api from '@/modules/startPage/api'
import useTopi from '@/modules/topi/useTopi'
import { t } from '@/plugins/i18n.ts'
import { PAGE_SIZE } from '@/types'
import { BatchProductPriceUpdate, StartPage, StartPageType } from '@/types/index'
import { concat } from 'lodash-es'
import { defineStore } from 'pinia'

interface StartPageState {
  startPage: StartPage
  loading: boolean
  loadingProducts: boolean
}

const initialState = (): StartPageState => {
  return {
    startPage: {
      startPageType: StartPageType.INDIVIDUAL,
      featuredProducts: []
    },
    loading: false,
    loadingProducts: false
  }
}

const useStartPage = defineStore('startPage', {
  state: () => initialState(),
  actions: {
    async loadStartPage(page: number, startPageSerial?: string) {
      this.loading = true

      return api
        .loadStartPage(page, PAGE_SIZE, startPageSerial)
        .then(({ data }) => {
          this.startPage = data
          if (data.featuredProducts.length > 0) {
            useTopi().setCartItems(this.startPage.featuredProducts)
          }
        })
        .catch((error: ApiError) => {
          handleApiError(error, {
            appearance: 'FULLPAGE',
            customMessage: t('error.startPage')
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async loadStartPageNextPage(page: number, startPageSerial?: string) {
      this.loadingProducts = true

      return api
        .loadStartPage(page, PAGE_SIZE, startPageSerial)
        .then(({ data }) => {
          this.startPage.featuredProducts = concat(
            this.startPage.featuredProducts,
            data.featuredProducts
          )
          if (data.featuredProducts.length > 0) {
            useTopi().setCartItems(this.startPage.featuredProducts)
          }
        })
        .catch(handleApiError)
        .finally(() => {
          this.loadingProducts = false
        })
    },
    updateProduct(update: BatchProductPriceUpdate) {
      const index = this.startPage.featuredProducts.findIndex(
        (item) => item.productId === update.productId
      )
      if (index >= 0) {
        const featuredProduct = this.startPage.featuredProducts[index]
        if (!featuredProduct) return
        featuredProduct.price = update.price
        featuredProduct.stock = update.stock
      }
    }
  }
})

export default useStartPage
